import { track } from "@core/tracking";
var openedUserProfileMenu = function() {
    track("opened user profile menu");
};
export var UserTracking = {
    openedUserProfileMenu: openedUserProfileMenu
};

//# sourceMappingURL=UserTracking.js.map